
















import Fieldset from '~/components/car/classifieds/form/fieldsets/handlers/Fieldset.vue'
import BaseFieldsetMixin from '~/components/car/classifieds/form/fieldsets/handlers/BaseFieldsetMixin.vue'
import { defineComponent, computed } from '@nuxtjs/composition-api'
import { APP_NS, AppState } from '~/store/modules/shared/app/state'
import { useNamespacedStore } from '~/compositions/store'
import { defineComponentTranslations } from '~/utils/i18n'

export default defineComponent({
  components: { Fieldset },
  mixins: [BaseFieldsetMixin],
  i18n: defineComponentTranslations({
    trade_your_classifieds: {
      en:
        'Now you can trade your classifieds with the classifieds of other {site} users, with just one swipe.',
      el:
        'Τώρα μπορείς να ανταλλάξεις τις αγγελίες σου με αγγελίες άλλων χρηστών του {site}, μόνο με ένα swipe.'
    }
  }),
  setup() {
    const { getters } = useNamespacedStore<AppState>(APP_NS)
    const isPlot = computed(() => getters('isPlot'))

    return {
      isPlot
    }
  }
})
